import { CONSUMER_PILLARS, IMAGES, PILLARS } from "../../lib/ablemp-data";
import { ShieldCheck, Scale, TrendingDown, HeartHandshake } from "lucide-react";

const ICONS = [HeartHandshake, Scale, TrendingDown, ShieldCheck];

export const Causes = () => {
  return (
    <section
      id="causas"
      data-testid="causes-section"
      className="relative bg-[#0A0F14] text-white py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grain-dark opacity-50 pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 text-[11px] uppercase tracking-[0.3em] text-white/55">
          <span className="flag-rule" aria-hidden />
          <span>§ 02 — Por que a causa importa</span>
        </div>

        <div className="mt-10 grid grid-cols-12 gap-8">
          <h2
            data-testid="causes-headline"
            className="col-span-12 lg:col-span-10 font-serif-display text-[36px] sm:text-[52px] lg:text-[80px] leading-[1.02] tracking-[-0.02em]"
          >
            Recusar um meio de pagamento é{" "}
            <span className="italic font-light text-[#009B3A]">
              ferir
            </span>{" "}
            o Código de Defesa do Consumidor.
          </h2>
        </div>

        <p className="mt-10 max-w-2xl text-white/75 text-lg leading-relaxed">
          A liberdade de escolha é essencial para o fomento dos negócios e para
          a proteção dos consumidores. Quando ela é restringida, perdem o
          cidadão, o pequeno empresário e a economia.
        </p>

        {/* Society Pillars analytical grid */}
        <div className="mt-16">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <h3 className="font-serif-display text-2xl md:text-3xl">
              Benefícios para a sociedade
            </h3>
            <span className="text-[11px] uppercase tracking-[0.3em] text-white/45">
              04 pilares
            </span>
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {PILLARS.map((p, i) => {
              const Icon = ICONS[i];
              return (
                <div
                  key={p.label}
                  data-testid={`pillar-${i}`}
                  className="group bg-[#0A0F14] hover:bg-[#131C24] p-7 md:p-8 transition-colors duration-500"
                >
                  <div className="flex items-start justify-between">
                    <span className="font-serif-display text-2xl text-[#FEDF00]">
                      0{i + 1}
                    </span>
                    <Icon size={22} className="text-white/55 group-hover:text-[#FEDF00] transition-colors" strokeWidth={1.4} />
                  </div>
                  <h4 className="mt-8 font-serif-display text-xl leading-tight">
                    {p.label}
                  </h4>
                  <p className="mt-3 text-sm text-white/65 leading-relaxed">
                    {p.body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Consumer pillars + image */}
        <div className="mt-20 grid grid-cols-12 gap-8 lg:gap-12">
          <div className="col-span-12 lg:col-span-6">
            <div
              data-testid="causes-image"
              className="relative aspect-[5/4] overflow-hidden border border-white/10"
            >
              <img
                src={IMAGES.realNotesStack}
                alt="Cédulas de Real empilhadas — dinheiro físico no cotidiano"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#0A0F14]/80 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 p-6 max-w-sm">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#FEDF00]">
                  Cidadão
                </div>
                <div className="mt-2 font-serif-display text-xl leading-tight">
                  No balcão, no mercado, no transporte — o direito de escolher
                  precisa estar presente. Do troco em moedas ao Pix.
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-6">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/55">
              Benefícios para o consumidor
            </div>
            <h3 className="mt-3 font-serif-display text-3xl md:text-4xl leading-tight">
              Quatro pilares que protegem quem paga.
            </h3>

            <ul className="mt-8 divide-y divide-white/10 border-y border-white/10">
              {CONSUMER_PILLARS.map((label, idx) => (
                <li
                  key={label}
                  data-testid={`consumer-pillar-${idx}`}
                  className="flex items-center justify-between py-5 group"
                >
                  <div className="flex items-center gap-6">
                    <span className="font-serif-display text-2xl text-white/40 w-10">
                      0{idx + 1}
                    </span>
                    <span className="font-serif-display text-xl md:text-2xl group-hover:text-[#FEDF00] transition-colors">
                      {label}
                    </span>
                  </div>
                  <span className="h-px w-10 bg-white/30 group-hover:bg-[#FEDF00] group-hover:w-16 transition-all" />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Causes;
